<template>
  <nav class="kids-store-nav" aria-label="Kids store navigation">
    <div class="kids-store-nav__inner">
      <router-link
        :to="{ name: storeRoute }"
        class="kids-store-nav__brand"
        :class="{ 'kids-store-nav__brand--active': isStoreHome }"
      >
        <i class="fa-solid fa-child-reaching" aria-hidden="true" />
        <span>Kids Store</span>
      </router-link>

      <div class="kids-store-nav__actions">
        <router-link
          :to="{ name: storeRoute }"
          class="kids-store-nav__link"
          :class="{ 'kids-store-nav__link--active': isStoreHome }"
        >
          <i class="fa-solid fa-grid-2" aria-hidden="true" />
          <span class="kids-store-nav__link-text">Browse</span>
        </router-link>

        <router-link
          :to="{ name: cartRoute }"
          class="kids-store-nav__cart"
          :class="{ 'kids-store-nav__cart--active': isCartPage }"
          aria-label="Kids shopping cart"
        >
          <i class="fa-solid fa-cart-shopping" aria-hidden="true" />
          <span class="kids-store-nav__link-text">Cart</span>
          <span v-if="cartCount > 0" class="kids-store-nav__badge" aria-hidden="true">
            {{ cartCount > 99 ? "99+" : cartCount }}
          </span>
        </router-link>
      </div>
    </div>
  </nav>
</template>

<script>
import { useKidsCartStore } from "@/cartstore/kidsCartStore";
import { KIDS_CART_ROUTE, KIDS_STORE_ROUTE } from "../constants";

export default {
  name: "KidsStoreNav",
  setup() {
    const kidsCartStore = useKidsCartStore();
    return { kidsCartStore };
  },
  data() {
    return {
      storeRoute: KIDS_STORE_ROUTE,
      cartRoute: KIDS_CART_ROUTE,
    };
  },
  computed: {
    cartCount() {
      return this.kidsCartStore.cartCount;
    },
    isStoreHome() {
      return this.$route.name === KIDS_STORE_ROUTE;
    },
    isCartPage() {
      return this.$route.name === KIDS_CART_ROUTE;
    },
  },
};
</script>

<style scoped>
.kids-store-nav {
  position: sticky;
  top: max(60px, calc(env(safe-area-inset-top, 0px) + 56px));
  z-index: 90;
  width: 100%;
  background: color-mix(in srgb, var(--background-color2) 92%, transparent);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid color-mix(in srgb, var(--border-color) 70%, transparent);
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.06);
}

.kids-store-nav__inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  padding: 0.55rem clamp(0.875rem, 3.5vw, 2.75rem);
  box-sizing: border-box;
}

.kids-store-nav__brand {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  font-size: 0.88rem;
  font-weight: 700;
  color: var(--text-color1);
  text-decoration: none;
  white-space: nowrap;
}

.kids-store-nav__brand i {
  color: var(--border-color-hover);
}

.kids-store-nav__brand--active,
.kids-store-nav__brand:hover {
  color: var(--border-color-hover);
}

.kids-store-nav__actions {
  display: flex;
  align-items: center;
  gap: 0.35rem;
}

.kids-store-nav__link,
.kids-store-nav__cart {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.45rem 0.75rem;
  border-radius: 999px;
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--text-color2);
  text-decoration: none;
  transition: background 0.15s ease, color 0.15s ease;
}

.kids-store-nav__link:hover,
.kids-store-nav__cart:hover,
.kids-store-nav__link--active,
.kids-store-nav__cart--active {
  background: color-mix(in srgb, var(--border-color-hover) 14%, transparent);
  color: var(--text-color1);
}

.kids-store-nav__cart {
  position: relative;
  color: var(--text-color1);
}

.kids-store-nav__badge {
  position: absolute;
  top: -2px;
  right: 2px;
  min-width: 1.1rem;
  height: 1.1rem;
  padding: 0 0.25rem;
  border-radius: 999px;
  background: var(--border-color-hover);
  color: #fff;
  font-size: 0.62rem;
  font-weight: 800;
  line-height: 1.1rem;
  text-align: center;
}

@media (max-width: 480px) {
  .kids-store-nav__inner {
    padding: 0.45rem clamp(0.65rem, 4vw, 1rem);
  }

  .kids-store-nav__brand {
    font-size: 0.8rem;
    gap: 0.35rem;
  }

  .kids-store-nav__brand span {
    max-width: 9rem;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .kids-store-nav__link-text {
    display: none;
  }

  .kids-store-nav__cart,
  .kids-store-nav__link {
    padding: 0.5rem 0.65rem;
    min-width: 40px;
    min-height: 40px;
    justify-content: center;
  }
}

@media (max-width: 360px) {
  .kids-store-nav__brand span {
    max-width: 7rem;
  }
}

@media (max-height: 500px) and (orientation: landscape) {
  .kids-store-nav {
    top: max(48px, calc(env(safe-area-inset-top, 0px) + 44px));
  }

  .kids-store-nav__inner {
    padding-block: 0.35rem;
  }
}
</style>
